import { Link } from "react-router-dom";

const ListContent = {
  Blog_1: {
    step_1: {
      liss: [
        {
          bold: "Tip : ",
          item: "Ask your doctor for trusted resources or read credible online articles. Keep a notebook for questions and notes to help during consultations.",
        },
      ],
    },
    step_2: {
      liss2: [
        {
          bold: "Tip : ",
          item: "Consider joining a class at your fertility clinic where they teach proper injection techniques. Some clinics even offer instructional videos.",
        },
      ],
    },
    step_3: {
      liss3: [
        {
          bold: "Diet: ",
          item: "Eat a nutrient-rich diet full of fruits, vegetables, whole grains, and lean proteins. Foods rich in antioxidants and omega-3s are beneficial for reproductive health.",
        },
        {
          bold: "Exercise: ",
          item: "Engage in moderate, low-impact exercises like walking or swimming. Avoid intense workouts, which can negatively affect hormone levels.",
        },
        {
          bold: "Supplements: ",
          item: " Your fertility specialist may recommend certain vitamins, such as folic acid, vitamin D, and CoQ10, to enhance fertility.",
        },
        {
          bold: "Tip: ",
          item: "Maintain a balanced lifestyle without over-stressing your body. This can improve your body's response to fertility treatments.",
        },
      ],
    },
    step_4: {
      liss4: [
        {
          bold: "Support System: ",
          item: "Surround yourself with supportive friends, family, or a partner who can offer encouragement. Consider joining an IVF support group to connect with others on the same journey.",
        },
        {
          bold: "Stress Management: ",
          item: "Practice stress-reduction techniques such as mindfulness, meditation, or yoga. Many fertility centers also offer counseling or therapy services to help manage stress or anxiety related to the process.",
        },
        {
          bold: "Tip: ",
          item: "Prioritize self-care routines that help you relax and recharge, whether it's reading, taking baths, or spending time with loved ones.",
        },
      ],
    },
    step_5: {
      liss5: [
        {
          bold: "Initial Consultation: ",
          item: "Ensure that you and your partner (if applicable) attend an initial consultation where the fertility specialist will review your medical history and run tests like blood work, ultrasounds, or sperm analysis.",
        },
        {
          bold: "Screenings and Testing: ",
          item: "Before IVF, both partners may need screenings for infectious diseases, hormone levels, and general reproductive health. These tests ensure that you're ready to proceed with the IVF cycle safely.",
        },
        {
          bold: "Tip: ",
          item: "Keep a folder or digital file to store all your test results, doctor's recommendations, and appointment schedules.",
        },
      ],
    },
    step_6: {
      liss6: [
        {
          bold: "Cost Breakdown: ",
          item: (
            <>
              <Link to="/Programme/IVF" className="blogLink">
                IVF
              </Link>
              typically includes expenses for medications, monitoring
              appointments, and procedures like egg retrieval and embryo
              transfer. Ask for a detailed cost estimate from your fertility
              clinic.
            </>
          ),
        },
        {
          bold: "Insurance Coverage: ",
          item: "Investigate whether your health insurance covers any part of the IVF treatment, including medications or diagnostic tests.",
        },
        {
          bold: "Financing Options: ",
          item: "Some clinics offer financing plans, grants, or discounts. Explore these options if you need assistance in covering costs.",
        },
        {
          bold: "Tip: ",
          item: "Set a realistic budget and plan for extra expenses, as additional treatments like genetic testing or embryo freezing might be recommended during the process.",
        },
      ],
    },
    step_7: {
      liss7: [
        {
          bold: "Work Schedule: ",
          item: "Plan for time off from work, especially during critical stages like egg retrieval and embryo transfer. Some people need a few days to recover physically and emotionally after these procedures.",
        },
        {
          bold: "Home Support: ",
          item: "Arrange for extra help at home, whether that's hiring a babysitter, asking for help with household chores, or simply having someone available for emotional support.",
        },
        {
          bold: "Tip: ",
          item: "Speak openly with your employer (if comfortable) to see if flexible work hours or remote options are available during your IVF treatment cycle.",
        },
      ],
    },
    step_8: {
      liss8: [
        {
          bold: "Realistic Expectations: ",
          item: "IVF can be unpredictable, and it's important to manage expectations. Success rates vary based on factors such as age, health conditions, and fertility history.",
        },
        {
          bold: "Resilience: ",
          item: "Try to stay hopeful and resilient. Each step in the process brings you closer to your goal, even if it doesn't happen as quickly as you hope.",
        },
        {
          bold: "Tip: ",
          item: "Focus on progress and celebrate small milestones along the way.",
        },
      ],
    },
  },

  Blog_2: {
    L1: {
      liss: [
        {
          bold: "PGT-A (Preimplantation Genetic Testing for Aneuploidy): ",
          item: "This test screens embryos for chromosomal abnormalities, which can lead to conditions like Down syndrome or increase the risk of miscarriage. By identifying chromosomally normal embryos, PGT-A enhances the chances of a successful pregnancy.",
        },
        {
          bold: "PGT-M (Preimplantation Genetic Testing for Monogenic Disorders): ",
          item: "This testing is used to identify specific genetic conditions that can be passed from parent to child, such as cystic fibrosis or sickle cell disease. PGT-M helps prospective parents understand the genetic risks associated with their embryos.",
        },
        {
          bold: "Tip: ",
          item: "Discuss with your fertility specialist whether PGT is appropriate for your situation. Understanding your genetic risks can lead to informed decisions regarding embryo selection.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Risk Assessment: ",
          item: "The counselor will evaluate your family history and any previous genetic testing results to provide a personalized risk assessment for inherited conditions.",
        },
        {
          bold: "Informed Decision-Making: ",
          item: "With a clearer understanding of genetic risks, couples can make informed decisions about whether to proceed with IVF, which embryos to transfer, or whether to consider options such as donor gametes or adoption.",
        },
        {
          bold: "Support and Resources: ",
          item: "Genetic counselors also offer emotional support and can connect you with additional resources, such as support groups for families facing genetic challenges.",
        },
      ],
    },

    L3: {
      liss3: [
        {
          bold: "Embryo Quality: ",
          item: "The genetic health of an embryo directly influences its quality. Chromosomally normal embryos have a higher likelihood of implantation and developing into a healthy pregnancy. PGT-A can help identify high-quality embryos for transfer.",
        },
        {
          bold: "",
          item: (
            <>
              Age Factors: The age of the egg provider is a significant factor
              in{" "}
              <Link to="/Programme/IVF" className="blogLink">
                IVF success
              </Link>
              . Women in their 20s and early 30s tend to produce higher-quality
              eggs, while women over 35 may experience a decline in egg quality
              and quantity. Understanding these age-related factors is essential
              for couples considering IVF.
            </>
          ),
        },
        {
          bold: "Sperm Quality: ",
          item: "Just as egg quality is critical, sperm quality also impacts embryo development. Genetic testing of sperm can identify potential issues, such as chromosomal abnormalities or mutations, which could affect the health of the resulting embryos.",
        },
        {
          bold: "Tip: ",
          item: "Discuss the potential impact of genetics on your IVF success rates with your fertility specialist. Understanding these factors can help set realistic expectations for your treatment journey.",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Chromosomal Abnormalities: ",
          item: "Conditions such as Turner syndrome or Klinefelter syndrome are caused by chromosomal abnormalities and can lead to fertility issues. Couples with a known history of these conditions may benefit from genetic testing to identify risks.",
        },
        {
          bold: "Single-Gene Disorders: ",
          item: "Couples with a family history of single-gene disorders, such as Huntington's disease, can use PGT-M to ensure that embryos do not carry the harmful gene mutations.",
        },
        {
          bold: "Carrier Screening: ",
          item: "Before undergoing IVF, prospective parents may opt for carrier screening to determine if they are carriers of specific genetic disorders. This information can influence decisions about embryo selection or donor gametes.",
        },
        {
          bold: "Tip: ",
          item: (
            <>
              Consult with a genetic counselor or fertility specialist to
              understand the implications of specific genetic conditions for
              your{" "}
              <Link to="/Programme/IVF" className="blogLink">
                IVF journey
              </Link>
              .
            </>
          ),
        },
      ],
    },

    L5: {
      liss5: [
        {
          bold: "Informed Consent: ",
          item: "It's essential for patients to fully understand the potential implications of genetic testing and the decisions that may arise from the results. Informed consent is crucial in navigating these ethical dilemmas.",
        },
        {
          bold: "Regulatory Oversight: ",
          item: "Genetic testing practices are subject to regulatory oversight to ensure patient safety and ethical considerations are addressed. Understanding the regulatory landscape can help patients navigate their choices.",
        },
        {
          bold: "Tip: ",
          item: "Engage in open conversations with your fertility clinic regarding ethical considerations surrounding genetic testing. Ensure that your values align with the practices of your healthcare team.",
        },
      ],
    },
  },

  Blog_3: {
    L1: {
      liss: [
        {
          bold: "Ovarian Reserve: ",
          item: "Women are born with a finite number of eggs, and as they age, both the quantity and quality of these eggs decrease. Diminished ovarian reserve can lead to lower success rates with IVF.",
        },
        {
          bold: "Chromosomal Abnormalities: ",
          item: "Older eggs are more likely to have chromosomal abnormalities, increasing the risk of miscarriage and genetic conditions in offspring. This factor can influence decisions regarding genetic testing of embryos during the IVF process.",
        },
        {
          bold: "Hormonal Changes: ",
          item: "As women age, hormonal fluctuations can affect ovulation, making it more challenging to conceive naturally or through assisted reproductive technologies like IVF.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Ages 20-34: ",
          item: "IVF success rates are around 40% to 50%.",
        },
        {
          bold: "Ages 35-37: ",
          item: "Success rates drop to approximately 30% to 40%.",
        },
        {
          bold: "Ages 38-40: ",
          item: "Success rates further decline to 20% to 30%.",
        },
        {
          bold: "Ages 41-42: ",
          item: "Success rates fall to about 10% to 15%.",
        },
        {
          bold: "Ages 43 and above: ",
          item: "The likelihood of success is typically less than 5%.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Health Status: ",
          item: "Overall health, including any pre-existing medical conditions, can affect fertility. Women with conditions like polycystic ovary syndrome (PCOS) or endometriosis may face additional challenges, and their optimal age for IVF may differ.",
        },
        {
          bold: "Lifestyle Choices: ",
          item: "Factors such as diet, exercise, smoking, and alcohol consumption can impact fertility. Maintaining a healthy lifestyle can improve IVF success rates, regardless of age.",
        },
        {
          bold: "Financial Considerations: ",
          item: "IVF can be costly, and many insurance plans do not cover the entire procedure. It’s essential to assess your financial situation and consider whether you can afford multiple cycles if necessary.",
        },
        {
          bold: "Emotional Readiness: ",
          item: "The emotional toll of infertility treatments can be significant. Ensure that you and your partner are emotionally prepared for the IVF process, as well as the potential challenges that may arise.",
        },
        {
          bold: "Partner's Age and Health: ",
          item: "If you have a partner, their age and health status should also be taken into account, as male fertility can influence overall success.",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "When to Consider Freezing Eggs: ",
          item: "Women in their late 20s to early 30s who are not ready to conceive but wish to preserve their fertility for future use can benefit from egg freezing. The earlier the eggs are frozen, the higher the likelihood of obtaining viable embryos later.",
        },
        {
          bold: "Consideration for Same-Sex Couples: ",
          item: (
            <>
              Couples in same-sex relationships may also consider fertility
              preservation or IVF with donor sperm to plan for future family
              building.
              <h4 className="mt-3">Choosing the Right Time to Begin IVF</h4>
            </>
          ),
        },
        {
          bold: "The choice of when to begin IVF",
          item: " is ultimately quite personal and should be chosen after giving careful thought to a number of variables. The following steps will assist in directing your decision-making process:",
        },
        {
          bold: "Speak with an Expert in Fertility: ",
          item: "Make an appointment for a consultation with a reproductive specialist to go over your unique circumstances, including age, health, and fertility issues.",
        },
        {
          bold: "Evaluate Your Choices: ",
          item: "Determine which reproductive alternatives are best for you based on your situation, such as beginning IVF right away, saving eggs for later use, or thinking about other family-building possibilities.",
        },
      ],
    },
  },

  Blog_4: {
    L1: {
      liss: [
        {
          bold: "AI in Embryo Selection: ",
          item: "AI algorithms can now assess embryo quality more precisely than traditional methods. By analyzing time-lapse images of embryos, AI can identify subtle developmental patterns and predict which embryos have the highest chance of leading to a successful pregnancy. This technology helps reduce subjectivity in embryo selection and increases implantation rates.",
        },
        {
          bold: "Predictive Analytics: ",
          item: "AI-powered predictive models can evaluate multiple factors, such as patient age, medical history, and hormone levels, to forecast the success of IVF cycles. This allows for a more personalized treatment approach, optimizing protocols for each individual patient.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Expanded PGT: ",
          item: "The latest versions of PGT offer broader genetic screening, allowing specialists to test for a wider range of genetic conditions beyond traditional chromosomal abnormalities. Expanded PGT can identify inherited diseases, such as cystic fibrosis or Tay-Sachs disease, ensuring that only healthy embryos are selected for transfer.",
        },
        {
          bold: "Non-Invasive Genetic Testing (niPGT): ",
          item: "One of the most anticipated innovations in 2024 is the development of non-invasive genetic testing methods. Traditional PGT involves taking a biopsy from the embryo, but niPGT uses DNA fragments from the culture media surrounding the embryo to conduct genetic screening. This non-invasive method reduces the risk of damaging the embryo while still providing valuable genetic information.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Preventing Inherited Diseases: ",
          item: "CRISPR technology can be used to edit out genetic mutations in embryos that may lead to serious inherited diseases. This approach could potentially prevent conditions such as Huntington's disease, muscular dystrophy, or certain cancers from being passed down to future generations.",
        },
        {
          bold: "Ethical Considerations: ",
          item: "While the possibilities of gene editing are exciting, they also raise significant ethical concerns. In 2024, regulatory bodies continue to discuss guidelines and restrictions on the use of CRISPR in IVF, balancing the potential benefits with ethical responsibilities.",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Improved Embryo Viability Assessment: ",
          item: "Time-lapse imaging captures thousands of images of embryos at various stages of development. With more advanced image analysis software available in 2024, embryologists can make more accurate assessments of embryo health and choose the most viable ones for transfer.",
        },
        {
          bold: "Minimizing Human Error: ",
          item: "Traditional embryo assessments require manual observations, which can sometimes lead to errors or inconsistencies. Time-lapse imaging minimizes these risks, allowing for more objective and standardized monitoring of embryo development.",
        },
      ],
    },
    L5: {
      liss5: [
        {
          bold: "Robotic Egg Retrieval: ",
          item: "Robotic systems assist in egg retrieval by enhancing precision during the procedure. Robotic assistance reduces the risk of complications and increases the number of viable eggs collected, leading to better outcomes.",
        },
        {
          bold: "Micromanipulation in ICSI (Intracytoplasmic Sperm Injection): ",
          item: "ICSI is a technique where a single sperm is injected directly into an egg to aid fertilization. In 2024, robotic micromanipulation tools provide more accurate sperm injection, improving fertilization rates and minimizing the risk of damage to the egg.",
        },
      ],
    },
    L6: {
      liss6: [
        {
          bold: "Ovulation Monitoring: ",
          item: "Wearable devices can monitor a woman's ovulation cycle by tracking physiological indicators like body temperature, hormone levels, and sleep patterns. This data helps fertility specialists fine-tune treatment timing to maximize success.",
        },
        {
          bold: "Personalized Fertility Insights: ",
          item: "In 2024, wearable devices are equipped with advanced AI algorithms that provide personalized insights into fertility health. Patients can receive real-time feedback on how their lifestyle choices impact fertility and adjust their habits to improve IVF outcomes.",
        },
      ],
    },
    L7: {
      liss7: [
        {
          bold: "Vitrification: ",
          item: "Vitrification, a rapid-freezing method, has become the standard for preserving eggs and embryos. In 2024, advancements in vitrification technology are leading to even higher survival rates during thawing, ensuring that more frozen eggs and embryos remain viable for future use.",
        },
        {
          bold: "Fertility Preservation for Medical Reasons: ",
          item: "Individuals facing medical treatments that may compromise fertility, such as chemotherapy, can benefit from the improved success rates of egg and embryo freezing, ensuring that their future reproductive options are preserved.",
        },
      ],
    },
  },

  Blog_5: {
    L1: {
      liss: [
        {
          bold: "Anxiety and Stress: ",
          item: (
            <>
              A number of medical procedures, such as hormone injections, egg
              retrieval, and embryo transfer, are part of{" "}
              <Link to="/Programme/IVF" className="blogLink">
                IVF therapy.{" "}
              </Link>{" "}
              The physical challenges and the unknown nature of the outcome
              frequently cause tension and anxiety to spike. Many are concerned
              about how they will handle failure, how many cycles they will
              require, and whether the treatment will be effective.
            </>
          ),
        },
        {
          bold: "Ups and downs in emotions: ",
          item: "Mood can be greatly impacted by the hormonal drugs used during in vitro fertilization. Hormone fluctuations can cause mood swings, irritation, or heightened sensitivity, which can cause stress in relationships and frustration.",
        },
        {
          bold: "Despondency: ",
          item: "Feelings of pessimism or depression can arise from repeated failures or extended intervals without periods. The psychological toll that infertility takes, particularly when paired with social demands.",
        },
        {
          bold: "Isolation Feelings: ",
          item: "Many people going through IVF could feel alone since they think other people can't truly get how difficult their experience is. People can isolate themselves even more from support systems by avoiding situations where the subject of children or pregnancy comes up at social events.",
        },
        {
          bold: "Stress in Relationships: ",
          item: "Love relationships may suffer as a result of the stress of reproductive treatments. Couples may have trouble expressing themselves, handling the financial strain of IVF, or handling varying emotional reactions to the procedure.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Enhancing Emotional Fortitude: ",
          item: "Support for mental health gives people and couples coping mechanisms to manage the emotional strain of in vitro fertilization. Throughout their therapy, patients can develop emotional resilience, improve their stress management skills, and hold onto hope with the correct kind of support.",
        },
        {
          bold: "Reducing Anxiety and Depression: ",
          item: "Therapies such as counseling and cognitive-behavioral therapy (CBT) are highly effective in reducing symptoms of anxiety and depression that commonly arise during IVF. Professional support can help individuals process their feelings and manage emotional responses more healthily.",
        },
        {
          bold: " Building Bonds with Others: ",
          item: (
            <>
              A number of medical procedures, such as hormone injections, egg
              retrieval, and embryo transfer, are part of{" "}
              <Link to="/Programme/IVF" className="blogLink">
                IVF therapy.{" "}
              </Link>{" "}
              The physical challenges and the unknown nature of the outcome
              frequently cause tension and anxiety to spike. Many are concerned
              about how they will handle failure, how many cycles they will
              require, and whether the treatment will be effective. Couples in
              therapy can find a secure place to freely communicate their
              feelings, worries, and fears without fear of being judged. During
              the{" "}
              <Link to="/Programme/IVF" className="blogLink">
                IVF procedure,{" "}
              </Link>
              counseling can help partners communicate and understand one
              another better, which can reduce tension and strengthen the
              relationship.
            </>
          ),
        },
        {
          bold: "Improving the Success of IVF: ",
          item: "Although sperm count or egg quality are not directly impacted by mental health support, research indicates that lowering stress and anxiety may have a positive effect on reproductive outcomes. Less stressed-out women tend to conceive more frequently after IVF. A supported and serene mind can improve general health and foster a more conducive environment for conception.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Consult a professional counselor: ",
          item: "It can be quite helpful to work with a therapist or counselor who specializes in fertility concerns. A mental health specialist can offer a secure setting for talking about the psychological effects of infertility, controlling expectations, and creating coping strategies for the highs and lows of IVF.",
        },
        {
          bold: "Join a Support Group: ",
          item: "Connecting with others who are undergoing IVF can help alleviate feelings of isolation. Support groups offer a community of people who understand the unique challenges of fertility treatments, providing empathy, encouragement, and shared experiences.",
        },
        {
          bold: "Use relaxation and mindfulness practices: ",
          item: "Deep breathing exercises, yoga, and meditation are examples of mindfulness practices that can ease tension and encourage calm. By promoting present-moment awareness, mindfulness techniques can lessen worry about the future and how treatments will turn out.",
        },
        {
          bold: "Continue your lines of communication open with your partner: ",
          item: "IVF may test even the closest relationships, so communication is important. Couples should communicate their emotions, support one another, and check in on a regular basis. Couples therapy can be very helpful in resolving conflicts and overcoming emotional barriers that may arise throughout treatment.",
        },
        {
          bold: "Have Reasonable Expectations: ",
          item: "It's critical to understand that getting pregnant through IVF is not a given. People might lessen the disappointment of a failed effort by planning for the prospect of several cycles and setting realistic expectations. Professionals in mental health can assist patients in controlling their expectations and building resilience.",
        },
        {
          bold: "Take Breaks When Needed: ",
          item: "The IVF process can be all-consuming, but it's essential to take breaks and engage in activities that bring joy and relaxation. Whether it's spending time with loved ones, pursuing hobbies, or simply resting, taking time for self-care is crucial during the emotionally demanding IVF journey.",
        },
      ],
    },
  },

  Blog_6: {
    L1: {
      liss: [
        {
          bold: "Purpose:",
          item: "Egg freezing is a proactive step taken to preserve fertility for the future, while IVF is typically used as a solution when someone is actively trying to conceive. Egg freezing is about postponing the decision to start a family, whereas IVF is focused on immediate pregnancy.",
        },
        {
          bold: "Timeline: ",
          item: "Egg freezing allows you to store eggs and use them years later when you're ready. IVF, on the other hand, is typically performed with the intent of achieving pregnancy within a short period.",
        },
        {
          bold: "Success Rates: ",
          item: "Egg freezing success rates depend on several factors, especially age. Younger women have higher-quality eggs, which increases the chance of successful fertilization later. IVF success rates are similarly affected by age and the health of both the egg and sperm at the time of treatment.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Professional and Individual Objectives: ",
          item: "Many women decide to freeze their eggs in order to focus on other aspects of their lives, Such as their careers, education, or personal growth. You can put off having children without sacrificing your chance of being fertile if you freeze your eggs.",
        },
        {
          bold: "Preserving Fertility Before Medical Treatments: ",
          item: "Egg freezing is a common choice for women undergoing certain medical treatments, such as radiation or chemotherapy for cancer. Freezing eggs in advance gives them the chance to conceive later because these therapies can harm the ovaries and impair fertility.",
        },
        {
          bold: "Fertility and Age: ",
          item: "Women in their 20s or early 30s can retain their younger, healthier eggs for later use by freezing them. Fertility decreases with age. When you're ready, freezing eggs early increases the likelihood of a successful pregnancy.",
        },
        {
          bold: "Command of Timing: ",
          item: "Freezing eggs gives you flexibility. With this option, you can schedule your pregnancy according to your own schedule, regardless of whether you're waiting for the proper partner or are just not ready to become a parent.",
        },
      ],
    },

    L3: {
      liss3: [
        {
          bold: "immediate Family Formation: ",
          item: "When a couple or person is ready to create a family but is having trouble conceiving, IVF is the recommended course of action. IVF offers a way to conceive right away, regardless of the cause obstructed fallopian tubes, male infertility, or other reproductive issues.",
        },
        {
          bold: "Use of Donor Eggs or Sperm: ",
          item: "IVF allows the use of donor eggs, sperm, or embryos, making it a great option for same-sex couples, single individuals, or those facing infertility. Egg freezing, in contrast, only preserves your own eggs.",
        },
        {
          bold: "Success Rates: ",
          item: "IVF technology has improved significantly over the years. For women under the age of 35, the success rate of IVF with fresh embryos can be as high as 40%. While age is still a critical factor, IVF remains one of the most effective fertility treatments available today.",
        },
        {
          bold: "Overcoming Infertility Challenges: ",
          item: "IVF is designed to help with specific fertility issues. From polycystic ovary syndrome (PCOS) to unexplained infertility, IVF can address various problems that other treatments may not resolve.",
        },
      ],
    },

    L4: {
      liss4: [
        {
          bold: "Age and Fertility Health: ",
          item: "Age is one of the most critical factors to consider. If you're in your late 20s or early 30s and are not ready for children but want to preserve your fertility, egg freezing might be a better option. For women in their late 30s or 40s, IVF might offer a higher chance of success.",
        },
        {
          bold: "Costs: ",
          item: "Both egg freezing and IVF can be expensive. While egg freezing involves the cost of retrieval and storage, IVF includes egg retrieval, fertilization, embryo transfer, and potentially multiple cycles. Be sure to discuss costs with your fertility specialist and explore insurance or financing options.",
        },
        {
          bold: "Emotional Considerations: ",
          item: "Both treatments can be emotionally taxing. Egg freezing can bring peace of mind about future fertility, but IVF can be more intense because of the immediate goal of pregnancy. Emotional support from family, friends, or fertility counselors can make a big difference.",
        },
        {
          bold: "Medical Considerations: ",
          item: "Not everyone is a candidate for egg freezing or IVF. Health conditions such as low ovarian reserve or certain reproductive disorders may impact your eligibility. A fertility specialist will assess your medical history and perform tests to determine the best course of action.",
        },
      ],
    },
  },

  Blog_7: {
    L1: {
      liss: [
        {
          bold: "Age: ",
          item: "Fertility naturally declines with age, especially after 35 for women, which can impact the ability to conceive again.",
        },
        {
          bold: "Health Issues: ",
          item: "Conditions like polycystic ovary syndrome (PCOS), endometriosis, or uterine fibroids may develop or worsen over time.",
        },
        {
          bold: "Male Factor Infertility: ",
          item: "Changes in sperm quality or quantity can occur, leading to difficulty in conceiving.",
        },
        {
          bold: "Lifestyle Factors: ",
          item: "Weight gain, smoking, alcohol consumption, or stress can negatively impact fertility.",
        },
        {
          bold: "Complications from Previous Pregnancies: ",
          item: "Scarring or damage from a previous delivery (such as a C-section) can make conceiving again more difficult.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Age and Declining Egg Quality: ",
          item: "Women who had their first child at a younger age may now face age-related fertility issues. Egg quality diminishes as women age, which can reduce the chances of successful fertilization and implantation during IVF. In these cases, doctors may recommend additional interventions like preimplantation genetic testing (PGT) or the use of donor eggs.",
        },
        {
          bold: "Male Factor Infertility: ",
          item: "Even if a couple didn’t experience male infertility issues during their first pregnancy, it’s possible for sperm quality to decrease over time. IVF treatments can be tailored to address male factor infertility, including intracytoplasmic sperm injection (ICSI), where a single sperm is injected directly into an egg to improve the chances of fertilization.",
        },
        {
          bold: "Unresolved Health Issues: ",
          item: "Conditions like PCOS, endometriosis, or hormonal imbalances may go undiagnosed or become more severe over time. These issues can affect the outcome of IVF. Addressing underlying health conditions is crucial to improving fertility and optimizing IVF success. ",
        },
        {
          bold: "Increased Emotional Pressure: ",
          item: "Going through IVF while already raising children can add another layer of stress. Balancing the physical and emotional demands of IVF with parenting can be challenging. Couples may feel the pressure to achieve a successful outcome quickly, which can add to the stress.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: " Consult with a Specialist: ",
          item: "Consulting with a reproductive physician who understands the subtleties of secondary infertility is essential. Your doctor can design a customized treatment plan for you based on your medical history, current health, and past reproductive success.",
        },
        {
          bold: "Take Care of the Basis Conditions: ",
          item: (
            <>
              Before{" "}
              <Link to="/Programme/IVF" className="blogLink">
                beginning IVF,{" "}
              </Link>
              it's critical to take care of any health conditions that might be
              causing secondary infertility. Being proactive will increase the
              chances of success with IVF, whether it is for treating male
              reproductive disorders, uterine fibroids, or Pcos.
            </>
          ),
        },
        {
          bold: "Consider Advanced IVF Techniques: ",
          item: "Depending on the underlying cause of infertility, advanced techniques like preimplantation genetic testing (PGT) or using donor eggs or sperm may be recommended. PGT can help identify chromosomal abnormalities that could lead to failed pregnancies or miscarriages, while donor eggs may be suggested if egg quality is significantly diminished due to age.",
        },
        {
          bold: "Manage Emotional Well-Being: ",
          item: "The emotional toll of IVF and secondary infertility can be heavy. Couples should seek support from a fertility counselor or therapist who specializes in infertility issues. Having a safe space to talk about the fears, frustrations, and disappointments that arise during this journey can make a huge difference in managing the stress of treatment.",
        },
        {
          bold: "Be Patient with the Process: ",
          item: "IVF is not a guaranteed success, and it often takes more than one cycle to achieve a pregnancy. While it can be discouraging, it’s important to remember that each cycle provides more information about your fertility health, and adjustments can be made along the way. Staying patient and hopeful is key, even when the process feels long and challenging.",
        },
        {
          bold: "Communicate with Your Partner: ",
          item: "Navigating secondary infertility can put a strain on relationships. Make sure to keep communication open and honest with your partner. Share your feelings, fears, and hopes as you go through IVF together. Mutual support can help you stay connected and focused during this emotionally taxing time.",
        },
      ],
    },
  },

  Blog_8: {
    L1: {
      liss: [
        {
          bold: "Leafy Greens ",
          item: "(Spinach, Kale): High in folic acid, which supports fetal development and egg health.",
        },
        {
          bold: "Whole Grains",
          item: " (Oats, Brown Rice): Rich in fiber and help balance blood sugar.",
        },
        {
          bold: "Healthy Fats ",
          item: "(Avocado, Nuts, Olive Oil): Crucial for hormone balance.",
        },
        {
          bold: "Antioxidant-Rich Fruits ",
          item: "(Blueberries, Citrus): Improve sperm and egg quality.",
        },
        {
          bold: "Lean Proteins ",
          item: "(Eggs, Chicken, Legumes): Supports ovulation and egg development.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "",
          item: "Processed foods",
        },
        {
          bold: "",
          item: "Excessive caffeine",
        },
        {
          bold: "",
          item: "Trans fats",
        },
        {
          bold: "",
          item: "Sugary drinks",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "",
          item: "Meditation or mindfulness",
        },
        {
          bold: "",
          item: "Deep-breathing exercises",
        },
        {
          bold: "",
          item: "Acupuncture",
        },
        {
          bold: "",
          item: "Spending time in nature",
        },
        {
          bold: "",
          item: "Talking to a therapist or fertility counselor",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "",
          item: "A BMI between 18.5 - 24.9 is ideal.",
        },
        {
          bold: "",
          item: "Losing just 5-10% of body weight can restore ovulation.",
        },
      ],
    },
    L5: {
      liss5: [
        {
          bold: "",
          item: "Obesity is linked to lower sperm quality and testosterone.",
        },
      ],
    },
    L6: {
      liss6: [
        {
          bold: "Smoking",
          item: " reduces egg count and can cause early menopause.",
        },
        {
          bold: "Alcohol ",
          item: "affects hormone levels and impairs ovulation.",
        },
      ],
    },
    L7: {
      liss7: [
        {
          bold: "",
          item: "Use ovulation predictor kits (OPKs)",
        },
        {
          bold: "",
          item: "Monitor cervical mucus",
        },
        {
          bold: "",
          item: "Track basal body temperature (BBT)",
        },
        {
          bold: "",
          item: "Use fertility tracking apps",
        },
      ],
    },
    L8: {
      liss8: [
        {
          bold: "",
          item: "Regular plastics → BPA-free containers",
        },
        {
          bold: "",
          item: "Harsh cleaners → Natural alternatives",
        },
        {
          bold: "",
          item: "Conventional skincare → Organic, fragrance-free products",
        },
      ],
    },
    L9: {
      liss9: [
        {
          bold: "",
          item: "Avoid hot tubs and tight underwear",
        },
        {
          bold: "",
          item: "Take zinc, selenium, and vitamin C",
        },
        {
          bold: "",
          item: "Reduce stress and alcohol",
        },
        {
          bold: "",
          item: "Stay physically active",
        },
      ],
    },
    L10: {
      liss10: [
        {
          bold: "",
          item: "AMH (Anti-Müllerian Hormone)",
        },
        {
          bold: "",
          item: "FSH (Follicle-Stimulating Hormone)",
        },
        {
          bold: "",
          item: "TSH (Thyroid)",
        },
        {
          bold: "",
          item: "LH (Luteinizing Hormone)",
        },
        {
          bold: "",
          item: "Sperm analysis for men",
        },
      ],
    },
    L11: {
      liss11: [
        {
          bold: "",
          item: "Aim for 7-8 hours of quality sleep",
        },
        {
          bold: "",
          item: "Avoid screens 1 hour before bed",
        },
        {
          bold: "",
          item: "Stick to a sleep routine",
        },
        {
          bold: "",
          item: "Reduce caffeine after 2 PM",
        },
      ],
    },
    L12: {
      liss12: [
        {
          bold: "Folic Acid",
          item: "",
        },
        {
          bold: "CoQ10 -",
          item: " Supports egg quality",
        },
        {
          bold: "Myo-Inositol -",
          item: " Balances hormones",
        },
        {
          bold: "Vitamin D -",
          item: " Boosts fertility for both genders",
        },
        {
          bold: "Omega-3 Fatty Acids -",
          item: " Supports reproductive health",
        },
      ],
    },
    L13: {
      liss13: [
        {
          bold: "",
          item: "1 year and are under 35",
        },
        {
          bold: "",
          item: "6 months and are over 35",
        },
      ],
    },
  },

  Blog_9: {
    L1: {
      liss: [
        {
          bold: "Under 35 years: ",
          item: "40% to 45% success rate",
        },
        {
          bold: "Ages 35-37: ",
          item: "30% to 40% success rate",
        },
        {
          bold: "Ages 38-40: ",
          item: "20% to 30% success rate",
        },
        {
          bold: "Over 40 years: ",
          item: "10% to 15% success rate",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Age of the Woman: ",
          item: "As previously mentioned, a woman's age is the most critical factor in IVF success. The quality of eggs declines with age, affecting fertilization rates and embryo viability.",
        },
        {
          bold: "Cause of Infertility: ",
          item: "Different infertility issues, such as ovulatory disorders, endometriosis, or male factor infertility, can impact success rates. Understanding the specific cause can help tailor the treatment approach.",
        },
        {
          bold: "Embryo Quality: ",
          item: "The quality of embryos plays a crucial role in the chances of implantation. Higher-quality embryos have a better likelihood of leading to a successful pregnancy.",
        },
        {
          bold: "Number of Embryos Transferred: ",
          item: "Transferring multiple embryos can increase the chances of success, but it also raises the risk of multiple pregnancies, which can complicate health outcomes.",
        },
        {
          bold: "Fertility Clinic Experience: ",
          item: "The expertise and technology available at a fertility clinic can significantly impact success rates. Clinics with experienced professionals and advanced technology tend to have higher success rates.",
        },
        {
          bold: "Lifestyle Factors: ",
          item: "Factors such as smoking, obesity, and alcohol consumption can negatively affect fertility and the likelihood of IVF success. Couples are encouraged to adopt healthier lifestyles to improve their chances.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Choose a Reputable Fertility Clinic: ",
          item: "Research clinics with high success rates and positive patient reviews. Consider their experience, technology, and the range of services offered.",
        },
        {
          bold: "Maintain a Healthy Lifestyle: ",
          item: "Adopting a healthy diet, regular exercise, and avoiding harmful substances can improve fertility. Both partners should aim to be in optimal health before starting IVF.",
        },
        {
          bold: "Stay Informed: ",
          item: "Educate yourself about the IVF process, including potential challenges and success rates. Understanding what to expect can help couples feel more prepared.",
        },
        {
          bold: "Communicate Openly: ",
          item: "Discuss feelings and concerns with your partner throughout the IVF journey. Open communication can help alleviate stress and strengthen your relationship.",
        },
        {
          bold: "Consider Counseling: ",
          item: "Many couples benefit from counseling or support groups during the IVF process. This support can provide coping strategies and a safe space to express feelings.",
        },
      ],
    },
  },

  Blog_10: {
    L1: {
      liss: [
        {
          bold: "Irregular Menstrual Cycles: ",
          item: "Women with PCOS often experience infrequent or prolonged menstrual periods, which can make ovulation unpredictable.",
        },
        {
          bold: "Excess Androgens: ",
          item: "Elevated levels of male hormones, such as testosterone, can lead to symptoms like acne, excess facial or body hair (hirsutism), and thinning hair on the scalp.",
        },
        {
          bold: "Polycystic Ovaries: ",
          item: "Many women with PCOS have enlarged ovaries containing multiple small cysts, which can be detected through ultrasound.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Irregular Ovulation: ",
          item: "One of the most significant effects of PCOS on fertility is irregular or absent ovulation. Without regular ovulation, conception becomes challenging. Many women with PCOS may experience anovulation (failure to ovulate), making it difficult to predict fertile windows.",
        },
        {
          bold: "Hormonal Imbalances: ",
          item: "The hormonal imbalances associated with PCOS can disrupt the delicate interplay between hormones necessary for ovulation and pregnancy. Elevated insulin levels can also contribute to weight gain and metabolic issues, further complicating fertility.",
        },
        {
          bold: "Increased Risk of Miscarriage: ",
          item: (
            <>
              Women with{" "}
              <Link to="/" className="blogLink">
                PCOS{" "}
              </Link>{" "}
              may face a higher risk of miscarriage due to hormonal imbalances,
              insulin resistance, and other factors. Understanding these risks
              is essential for those trying to conceive.
            </>
          ),
        },
        {
          bold: "Associated Health Conditions: ",
          item: "PCOS is often linked with other health conditions that can impact fertility, including obesity, type 2 diabetes, and cardiovascular issues. These conditions can complicate pregnancy and affect overall health.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Irregular or absent menstrual cycles",
          item: "",
        },
        {
          bold: "Signs of excess androgens ",
          item: "(e.g., hirsutism, acne)",
        },
        {
          bold: "Polycystic ovaries visible on ultrasound",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Lifestyle Modifications: ",
          item: "For many women with PCOS, lifestyle changes can significantly impact fertility. Maintaining a healthy weight through balanced nutrition and regular exercise can help regulate menstrual cycles, improve insulin sensitivity, and enhance ovulation.",
        },
        {
          bold: "Medications: ",
          item: (
            <>
              <ul>
                <li>
                  <i class="bx bx-right-arrow-circle"></i>
                  <b>Clomiphene Citrate: </b>
                  Often the first-line treatment for inducing ovulation in women
                  with PCOS, clomiphene works by stimulating the ovaries to
                  produce eggs.
                </li>
                <li>
                  <i class="bx bx-right-arrow-circle"></i>
                  <b>Metformin: </b>
                  This medication is commonly used to treat insulin resistance
                  associated with PCOS. It can help regulate menstrual cycles
                  and improve ovulation rates.
                </li>
                <li>
                  <i class="bx bx-right-arrow-circle"></i>
                  <b>Letrozole: </b>
                  An alternative to clomiphene, letrozole is used to induce
                  ovulation and has shown effectiveness in women with PCOS.
                </li>
                <li>
                  <i class="bx bx-right-arrow-circle"></i>
                  <b>Gonadotropins: </b>
                  For those who do not respond to oral medications, injectable
                  hormone treatments can stimulate the ovaries to produce eggs.
                </li>
              </ul>
            </>
          ),
        },
        {
          bold: "Assisted Reproductive Technologies (ART): ",
          item: (
            <>
              If other treatments are unsuccessful, assisted reproductive
              technologies such as In Vitro Fertilization (IVF) may be
              recommended.{" "}
              <Link to="/Programme/IVF" className="blogLink">
                IVF{" "}
              </Link>
              allows for greater control over the fertilization process and can
              increase the chances of conception.
            </>
          ),
        },
        {
          bold: "Surgery: ",
          item: "In certain cases, ovarian drilling may be considered. This laparoscopic procedure involves making small punctures in the ovaries to reduce androgen production and stimulate ovulation. However, it is typically reserved for women who do not respond to other treatments.",
        },
        {
          bold: "Managing Associated Conditions: ",
          item: "Addressing related health issues, such as obesity or diabetes, can improve overall health and enhance fertility. Collaborating with healthcare providers to manage these conditions is essential for women with PCOS.",
        },
      ],
    },
  },

  Blog_11: {
    L1: {
      liss: [
        {
          bold: "Improved Timing: ",
          item: "After ovarian stimulation, patients may not feel ready for an immediate transfer. FET allows time for the body to recover before proceeding with embryo transfer.",
        },
        {
          bold: "Multiple Chances of Pregnancy: ",
          item: "With FET, any embryos not used during a fresh IVF cycle can be frozen, stored, and used later, providing additional opportunities for pregnancy without the need for repeat ovarian stimulation.",
        },
        {
          bold: "Reduced Risks of Ovarian Hyperstimulation Syndrome (OHSS): ",
          item: "In certain cases, a “freeze-all” approach is used to reduce the risk of OHSS, a condition that can occur after hormone stimulation.",
        },
        {
          bold: "Genetic Screening Options: ",
          item: "FET also allows time for preimplantation genetic testing (PGT), which screens embryos for genetic abnormalities before transfer. This can improve the likelihood of a healthy pregnancy.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Prepare the Cycle: ",
          item: "Patients go through cycle preparation prior to the frozen embryo transfer. In order to get the uterine lining ready for embryo implantation, this may entail hormone therapies. For the embryo to successfully connect, the endometrium, the lining of the uterus, must be at its ideal thickness. Natural Cycle FET: To identify the ideal timing for transfer, natural hormone levels are tracked in women who have regular menstrual cycles. Hormone Replacement Therapy (HRT) Cycle FET: HRT, which includes progesterone and estrogen, is used to regulate the timing and guarantee the ideal thickness of the uterine lining in women with irregular cycles.",
        },
        {
          bold: "Monitoring: ",
          item: "Blood tests and ultrasounds are conducted to check hormone levels and endometrial thickness. Once the lining reaches an ideal thickness, the transfer date is scheduled.",
        },
        {
          bold: "Warming:  ",
          item: "On the day of the transfer, the embryos are carefully thawed. Cryopreservation advancements have made it possible for embryos to survive the freezing and thawing process with high success rates.",
        },
        {
          bold: " Embryo Transfer: ",
          item: (
            <>
              The{" "}
              <Link to="/Programme/EmbryoTransfer" className="blogLink">
                embryo{" "}
              </Link>{" "}
              is transferred to the uterus using a thin catheter. This is a
              minimally invasive procedure performed under ultrasound guidance
              to ensure accurate placement. Most women find the transfer process
              to be straightforward and minimally uncomfortable.
            </>
          ),
        },
        {
          bold: "Post-Transfer Care: ",
          item: "After the transfer, patients may be advised to rest and take medications, such as progesterone, to support implantation. The “two-week wait” begins, leading up to a pregnancy test to confirm successful implantation.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Increased Flexibility: ",
          item: "Patients and doctors can select a time when the body is hormonally balanced and physically ready for transfer.",
        },
        {
          bold: "Higher Success Rates: ",
          item: "Some studies suggest that FET cycles have higher success rates, as the body has time to return to a natural hormonal state post-stimulation, creating a more favorable environment for implantation.",
        },
        {
          bold: "Fewer Risks of Complications: ",
          item: "FET reduces risks associated with high hormone levels post-stimulation, making it safer for patients prone to complications.",
        },
        {
          bold: "Simplicity and Efficiency: ",
          item: "The FET process is often more straightforward than fresh embryo transfer, with fewer required medications and a shorter preparation time.",
        },
        {
          bold: "FET Statistics and Success Rates: ",
          item: "Thanks to developments in freezing techniques like vitrification, a quick-freezing procedure that reduces the creation of ice crystals, FET success rates have been continuously increasing. FET cycles for women under 35 can result in live birth rates of more than 50%, while success rates can vary depending on age, embryo quality, and other factors. FET provides many patients with a very successful way to become pregnant.",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Multiple Pregnancies: ",
          item: "When more than one embryo is transferred, there is a higher chance of twins or triplets, which can increase pregnancy risks.",
        },
        {
          bold: "Failed Implantation: ",
          item: "There is always a possibility that the embryo will not implant, even if all conditions are optimal.",
        },
        {
          bold: "Emotional Impact: ",
          item: "The emotional toll of waiting and potential outcomes can be challenging. Many patients find support through counseling, fertility support groups, or therapy beneficial.",
        },
      ],
    },
    L5: {
      liss5: [
        {
          bold: "Healthy Lifestyle: ",
          item: "Maintaining a balanced diet, moderate exercise, and stress management can help improve the likelihood of a successful outcome.",
        },
        {
          bold: "Adherence to Medication: ",
          item: "Follow all medication guidelines provided by your healthcare team to support the body’s readiness for implantation.",
        },
        {
          bold: "Support System: ",
          item: "Emotional and psychological support during this time can ease stress and contribute to a positive experience. Whether through family, friends, or professional counseling, having a support network can be invaluable.",
        },
      ],
    },
  },

  Blog_12: {
    L1: {
      liss1: [
        {
          bold: "",
          item: "Transferred immediately (fresh embryo transfer)",
        },
        {
          bold: "",
          item: "Frozen and transferred at a later time (frozen embryo transfer)",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Quicker process: ",
          item: "No waiting for another cycle; the transfer happens soon after fertilization.",
        },
        {
          bold: "Lower cost: ",
          item: "No need for cryopreservation (freezing) or thawing.",
        },
        {
          bold: "Immediate use of embryos: ",
          item: "Some patients prefer to use embryos right away, especially in time-sensitive cases.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Less optimal uterine environment: ",
          item: "The medications used for ovarian stimulation may impact endometrial receptivity, possibly affecting implantation.",
        },
        {
          bold: "Higher risk of OHSS: ",
          item: "Women at risk for ovarian hyperstimulation syndrome may not be ideal candidates for fresh transfer.",
        },
        {
          bold: "Limited flexibility: ",
          item: "Timing is critical; if the body isn’t hormonally ready, transfer may have to be canceled.",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Improved endometrial receptivity: ",
          item: "The body is not under the stress of stimulation drugs, often creating a more natural and supportive environment for implantation.",
        },
        {
          bold: "More control over timing: ",
          item: "Embryos can be transferred when the uterus is optimally prepared.",
        },
        {
          bold: "Reduced risk of OHSS: ",
          item: "Particularly beneficial for women at high risk for complications from fertility medications.",
        },
        {
          bold: "Higher success rates (in some cases): ",
          item: "Studies have shown that in certain groups, FET may lead to higher pregnancy and live birth rates.",
        },
      ],
    },
    L5: {
      liss5: [
        {
          bold: "Longer timeline: ",
          item: "You may have to wait one or more cycles before the actual embryo transfer.",
        },
        {
          bold: "Higher cost: ",
          item: "Includes expenses for freezing, storage, and thawing.",
        },
        {
          bold: "Possible embryo loss: ",
          item: "Though rare, not all embryos survive the freezing and thawing process.",
        },
      ],
    },
    L6: {
      liss6: [
        {
          bold: "Higher Live Birth Rates with FET: ",
          item: "A study published in The New England Journal of Medicine found that frozen embryo transfers resulted in higher live birth rates and fewer pregnancy complications in women with polycystic ovary syndrome (PCOS).",
        },
        {
          bold: "Better for High Responders: ",
          item: "Women who produce a large number of eggs in a single IVF cycle often benefit more from FET to reduce risks of OHSS and enhance implantation chances.",
        },
        {
          bold: "Fresh May Be Suitable for Some:",
          item: " Women with fewer eggs or those needing urgent transfer (due to age or health conditions) may still have great outcomes with fresh transfers.",
        },
      ],
    },
    L7: {
      liss7: [
        {
          bold: "Age and Ovarian Reserve ",
          item: "Women with advanced maternal age or low ovarian reserve may benefit from fresh transfers to avoid delaying the process.",
        },
        {
          bold: "Response to Stimulation ",
          item: "If your body responds strongly to fertility medications (producing many eggs), freezing embryos and transferring later may protect your health and improve implantation chances.",
        },
        {
          bold: "Medical History ",
          item: "Conditions like endometriosis, PCOS, or uterine abnormalities may influence which transfer method is more effective.",
        },
        {
          bold: "Embryo Quality ",
          item: "Advances in freezing techniques ensure that high-quality embryos can be preserved with minimal risk. If your embryos are strong, frozen transfer might offer a better chance.",
        },
        {
          bold: "Emotional and Financial Readiness ",
          item: "Some couples prefer a fresh transfer to shorten the emotional rollercoaster. Others want to take time to prepare physically, mentally, and financially making FET more appealing.",
        },
      ],
    },
    L8: {
      liss8: [
        {
          bold: "",
          item: "Success rates at your clinic",
        },
        {
          bold: "",
          item: "Embryo grading and freezing techniques",
        },
        {
          bold: "",
          item: "Customized treatment plans based on your specific diagnosis",
        },
      ],
    },
    L9: {
      liss9: [
        {
          bold: "",
          item: "Review your hormone levels",
        },
        {
          bold: "",
          item: "Assess your uterine health",
        },
        {
          bold: "",
          item: "Consider your personal preferences",
        },
        {
          bold: "",
          item: "Develop a personalized plan for your IVF journey",
        },
      ],
    },
  },

  Blog_13: {
    L1: {
      liss1: [
        {
          bold: "Blocked or damaged fallopian tubes",
          item: "",
        },
        {
          bold: "Male factor infertility (low sperm count or motility)",
          item: "",
        },
        {
          bold: "Endometriosis",
          item: "",
        },
        {
          bold: "Ovulation disorders",
          item: "",
        },
        {
          bold: "Unexplained infertility",
          item: "",
        },
        {
          bold: "Genetic disorders",
          item: "",
        },
        {
          bold: "Fertility preservation (e.g., egg freezing before cancer treatment)",
          item: "",
        },
        {
          bold: "Same-sex couples or single individuals wanting to conceive",
          item: "",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Ovarian Stimulation ",
          item: "Hormonal medications are used to stimulate the ovaries to produce multiple eggs. This increases the chances of successful fertilization.",
        },
        {
          bold: "Egg Retrieval ",
          item: "Once the follicles are mature, eggs are retrieved through a minor surgical procedure under sedation.",
        },
        {
          bold: "Sperm Collection ",
          item: "A sperm sample is collected from the male partner or a donor.",
        },
        {
          bold: "Fertilization ",
          item: "Eggs are fertilized with sperm in the lab. In some cases, Intracytoplasmic Sperm Injection (ICSI) is used to inject sperm directly into the egg.",
        },
        {
          bold: "Embryo Culture ",
          item: (
            <>
              {" "}
              <Link to="/Programme/EmbryoTransfer" className="blogLink">
                {" "}
                Fertilized embryos
              </Link>{" "}
              are monitored for a few days. The healthiest embryo(s) are
              selected for transfer.
            </>
          ),
        },
        {
          bold: "Embryo Transfer ",
          item: " The embryo is placed into the uterus using a thin catheter. This step is usually painless and takes just a few minutes.",
        },
        {
          bold: "Pregnancy Test ",
          item: "After about 10-14 days, a blood test is conducted to check if implantation and pregnancy occurred.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Age of the woman: ",
          item: "Younger women tend to have higher success rates due to better egg quality.",
        },
        {
          bold: "Embryo quality: ",
          item: "Stronger embryos are more likely to implant successfully.",
        },
        {
          bold: "Uterine health: ",
          item: "A healthy uterine environment increases the chance of implantation.",
        },
        {
          bold: "Cause of infertility: ",
          item: "Some conditions are more responsive to IVF than others.",
        },
        {
          bold: "Lifestyle: ",
          item: "Smoking, alcohol, and high stress can negatively impact success rates.",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Egg freezing ",
          item: "offers fertility preservation options for women delaying childbirth.",
        },
        {
          bold: "EmbryoScope ",
          item: "allows continuous monitoring of embryo development.",
        },
        {
          bold: "Mild stimulation protocols ",
          item: "aim to reduce side effects and costs.",
        },
      ],
    },
  },

  Blog_14: {
    L1: {
      liss1: [
        {
          bold: (
            <>
              The Significance of Mutual Support:
              <br />
            </>
          ),
          item: "Resilience is increased when partners provide one other with emotional, mental, and physical support throughout IVF. One individual shouldn't handle IVF by themselves. Even while the patient receiving physical therapy frequently takes center stage, their partner's emotional journey is equally genuine. Support entails being totally involved at every stage, not just being there. It entails demonstrating empathy, exchanging hopes and anxieties, and establishing a secure environment in which both parties can be vulnerable.",
        },
        {
          bold: (
            <>
              Go to appointments together:
              <br />
            </>
          ),
          item: "Attend treatment appointments and fertility consultations together whenever you can. This lessens the feeling of loneliness and gives both spouses a sense of equal involvement. Knowing that you're not alone throughout operations or in waiting areas is reassuring. Making the effort to be present during important events can offer tremendous emotional support, even when job or other obligations make it challenging.",
        },
        {
          bold: (
            <>
              Exhibit kindness and patience:
              <br />
            </>
          ),
          item: "Mood and energy levels may be impacted by IVF therapies, particularly hormone injections. It's critical to maintain empathy and patience. On difficult days, small gestures of kindness, such as a warm hug, a favorite dish, or an encouraging letter, can lift your partner's spirits. Keep in mind that each partner may respond differently to stress. Treat one other with kindness, particularly when emotions are running high or tempers are short.",
        },
        {
          bold: (
            <>
              Appreciate the Small Victories:
              <br />
            </>
          ),
          item: "Every accomplishment is a win, whether it's a strong lab result, a successful egg retrieval, or just surviving a challenging injection. It is easier to turn attention from the tension to the advancements being achieved when these milestones are acknowledged. Celebrate them with one another, even if it's just in modest yet significant ways.",
        },
        {
          bold: (
            <>
              Keep Your Privacy Safe:
              <br />
            </>
          ),
          item: "Sometimes, IVF can make intimacy seem solely practical or mechanical. Reconnecting both physically and emotionally outside of the therapeutic setting is crucial. Share recollections, go for a walk, or have a romantic night. Connection is what intimacy is all about, and keeping that connection strong keeps partners close during this trying time.",
        },
        {
          bold: (
            <>
              Never Be Afraid to Ask for Outside Help:
              <br />
            </>
          ),
          item: "Asking for assistance is OK. Speaking with someone outside the partnership, whether it be a close friend, a support group, or a fertility counselor, might offer insightful viewpoints. It might be lonely to struggle with fertility, but support systems let you know you're not alone. During this trying time, therapy—both individual and couple's counseling—can assist in processing feelings, clearing up misconceptions, and enhancing communication.",
        },
        {
          bold: (
            <>
              Stay Together and Don't Place the Blame:
              <br />
            </>
          ),
          item: 'If one partner is found to be the cause of infertility, they may occasionally feel accountable. Emotional disengagement and guilt may result from this. The fact that IVF is a collaborative process must not be overlooked. Stay away from assigning blame and concentrate on working as a team. Instead of using "you" and "me," use inclusive terms like "we" and "us." Remind each other that being able to conceive is not what defines your relationship or love.',
        },
      ],
    },
  },

  Blog_15: {
    L1: {
      liss1: [
        {
          bold: "",
          item: "Sleep is a period for hormone regulation and rest, not only a rest period for the body. Your body creates vital reproductive hormones like melatonin and gonadotropin-releasing hormone (GnRH) while you sleep deeply. These hormones are essential for controlling ovulation and preserving a regular menstrual cycle.",
        },
        {
          bold: "",
          item: "Poor sleep can affect the results of IVF in the following ways:",
        },
        {
          bold: "",
          item: "An imbalance in hormones: Hormone production is disrupted by irregular sleep patterns, and this can have an impact on ovulation, egg quality, and even embryo implantation.",
        },
        {
          bold: "",
          item: "Weakened Immunity: Sleep deprivation has an impact on the immune system, which is crucial during the IVF implantation stage.",
        },
        {
          bold: "",
          item: "Anxiety and mood swings: Lack of sleep causes emotional exhaustion, anxiety, and heightened irritability, all of which can exacerbate an already taxing procedure.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Stress Hormones vs. Reproductive Hormones: ",
          item: "High stress leads to the production of cortisol, a hormone that can interfere with estrogen and progesterone. These hormones are vital for ovulation and embryo implantation. When stress levels are high, it can create a hormonal imbalance that makes conception harder.",
        },
        {
          bold: "Lifestyle Choices: ",
          item: "Mental health affects behavior. High stress may lead to poor eating habits, disturbed sleep, or lack of motivation to follow medical routines—all of which can reduce IVF effectiveness.",
        },
        {
          bold: "Impact on Relationships: ",
          item: "Anxiety and emotional stress can also strain relationships. A supportive partner or family environment contributes to better emotional resilience during IVF.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Stick to a routine: ",
          item: "Go to bed and wake up at the same time every day.",
        },
        {
          bold: "Limit screen time before bed: ",
          item: "Blue light from phones or tablets can suppress melatonin.",
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: "Take a warm bath, listen to soft music, or try gentle breathing exercises.",
        },
        {
          bold: "Avoid heavy meals and caffeine in the evening. ",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_16: {
    L1: {
      liss1: [
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Stress Hormones vs. Reproductive Hormones: ",
          item: "High stress leads to the production of cortisol, a hormone that can interfere with estrogen and progesterone. These hormones are vital for ovulation and embryo implantation. When stress levels are high, it can create a hormonal imbalance that makes conception harder.",
        },
        {
          bold: "Lifestyle Choices: ",
          item: "Mental health affects behavior. High stress may lead to poor eating habits, disturbed sleep, or lack of motivation to follow medical routines—all of which can reduce IVF effectiveness.",
        },
        {
          bold: "Impact on Relationships: ",
          item: "Anxiety and emotional stress can also strain relationships. A supportive partner or family environment contributes to better emotional resilience during IVF.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Stick to a routine: ",
          item: "Go to bed and wake up at the same time every day.",
        },
        {
          bold: "Limit screen time before bed: ",
          item: "Blue light from phones or tablets can suppress melatonin.",
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: "Take a warm bath, listen to soft music, or try gentle breathing exercises.",
        },
        {
          bold: "Avoid heavy meals and caffeine in the evening. ",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_17: {
    L1: {
      liss1: [
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Stress Hormones vs. Reproductive Hormones: ",
          item: "High stress leads to the production of cortisol, a hormone that can interfere with estrogen and progesterone. These hormones are vital for ovulation and embryo implantation. When stress levels are high, it can create a hormonal imbalance that makes conception harder.",
        },
        {
          bold: "Lifestyle Choices: ",
          item: "Mental health affects behavior. High stress may lead to poor eating habits, disturbed sleep, or lack of motivation to follow medical routines—all of which can reduce IVF effectiveness.",
        },
        {
          bold: "Impact on Relationships: ",
          item: "Anxiety and emotional stress can also strain relationships. A supportive partner or family environment contributes to better emotional resilience during IVF.",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Stick to a routine: ",
          item: "Go to bed and wake up at the same time every day.",
        },
        {
          bold: "Limit screen time before bed: ",
          item: "Blue light from phones or tablets can suppress melatonin.",
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: "Take a warm bath, listen to soft music, or try gentle breathing exercises.",
        },
        {
          bold: "Avoid heavy meals and caffeine in the evening. ",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_18: {
    L1: {
      liss1: [
        {
          bold: "Advanced Fertility Treatments:",
          item: " ICSI, PICSI, IVF, IMSI, spindle view ICSI, genetic testing, egg retrieval, laser-assisted hatching, blastocyst culture, ovarian stimulation, ERA, LIT, IUI.",
        },
        {
          bold: "Fertility Preservation:",
          item: "Sperm and testicular tissue freezing, egg freezing, ovarian tissue freezing, embryo freezing.",
        },
        {
          bold: "Donor Programs:",
          item: " Sperm donation, egg donation, and embryo donation services.",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Male Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Male Infertility
                </a>
              </strong>
              {" Solutions:"}
            </>
          ),
          item: "Treatment for low sperm count or motility using ICSI, sperm retrieval techniques, and hormonal therapy.",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Female Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Female Infertility
                </a>
              </strong>
              {" Care:"}
            </>
          ),
          item: " Treatment for ovarian issues, uterine abnormalities, endometriosis, fibroids, tubal blockages, menopause-related infertility, and more.",
        },
        {
          bold: "Ovarian Rejuvenation:",
          item: "Support for low AMH and advanced maternal age cases.",
        },
        {
          bold: "IVF Failure Management:",
          item: "Detailed evaluation of previous IVF cycles with genetic analysis, surgical corrections, and immunological therapies where required.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "",
          item: "State-of-the-art IVF laboratories and advanced embryology systems",
        },
        {
          bold: "",
          item: "Cost-effective IVF packages tailored to individual needs",
        },
        {
          bold: "",
          item: "Zero-interest EMI options for easy payment planning",
        },
        {
          bold: "",
          item: "Multiple centres across Mumbai for better accessibility",
        },
        {
          bold: "",
          item: "Multiple centres across Mumbai for better accessibility",
        },
        {
          bold: "",
          item: "Complete cycle care: ovum pickup, embryo transfer, and post-transfer monitoring",
        },
        {
          bold: "",
          item: "Strict hygiene, safety, and emotional support systems",
        },
        {
          bold: "",
          item: "Dedicated fertility support team for end-to-end guidance",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "What infertility treatments are available at Acme Fertility in Mumbai ?",
          item: (
            <>
              <br />
              We offer IVF, ICSI, IUI, donor programs, fertility preservation,
              and advanced reproductive treatments.
            </>
          ),
        },
        {
          bold: "What is the cost of IVF treatment in Mumbai ?",
          item: (
            <>
              <br />
              Costs typically range from ₹1,00,000 to ₹2,00,000 depending on the
              case.
            </>
          ),
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: (
            <>
              <br />
              Take a warm bath, listen to soft music, or try gentle breathing
              exercises.
            </>
          ),
        },
        {
          bold: "How many Acme Fertility centres are there in Mumbai and where are they located ? ",
          item: (
            <>
              <br />
              We have centres in Borivali, Thane, and Dombivli.
            </>
          ),
        },
        {
          bold: (
            <>
              {" "}
              {" Why choose Acme Fertility as the "}
              <strong>
                <a
                  href="https://www.acmefertility.com/Programme/IVF"
                  title="best IVF centre in Mumbai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  best IVF centre in Mumbai ? <br />
                </a>
              </strong>
            </>
          ),
          item: "Because of advanced technology, experienced specialists, personalized care, and strong success-focused treatment protocols.",
        },
        {
          bold: " What is the appropriate time to visit an IVF Specialist in Mumbai ? ",
          item: (
            <>
              <br />
              If you have been unsuccessful at conceiving for a year or longer,
              it is best to seek the guidance of a fertility specialist.
            </>
          ),
        },
        {
          bold: "What are the available infertility treatments ? ",
          item: (
            <>
              <br />
              Most commonly, infertility treatments include medications, IUI,
              IVF, and other advanced methods of infertility treatment{" "}
              <b>Mumbai</b>.
            </>
          ),
        },
        {
          bold: "What criteria should I use to select the best fertility clinic in Mumbai ? ",
          item: (
            <>
              <br />
              Select the clinic with the best experienced, most skilled, and
              highest qualified staff, most advanced technology, the most
              transparent processes, and best patient support.
            </>
          ),
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_19: {
    L1: {
      liss1: [
        {
          bold: "",
          item: " Advanced embryo freezing technology",
        },
        {
          bold: "",
          item: "Personalized hormone therapy plans",
        },
        {
          bold: "",
          item: "High-quality lab infrastructure",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Male Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Male Infertility
                </a>
              </strong>
              {" Solutions:"}
            </>
          ),
          item: "Treatment for low sperm count or motility using ICSI, sperm retrieval techniques, and hormonal therapy.",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Female Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Female Infertility
                </a>
              </strong>
              {" Care:"}
            </>
          ),
          item: " Treatment for ovarian issues, uterine abnormalities, endometriosis, fibroids, tubal blockages, menopause-related infertility, and more.",
        },
        {
          bold: "Ovarian Rejuvenation:",
          item: "Support for low AMH and advanced maternal age cases.",
        },
        {
          bold: "IVF Failure Management:",
          item: "Detailed evaluation of previous IVF cycles with genetic analysis, surgical corrections, and immunological therapies where required.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "",
          item: "State-of-the-art IVF laboratories and advanced embryology systems",
        },
        {
          bold: "",
          item: "Cost-effective IVF packages tailored to individual needs",
        },
        {
          bold: "",
          item: "Zero-interest EMI options for easy payment planning",
        },
        {
          bold: "",
          item: "Multiple centres across Mumbai for better accessibility",
        },
        {
          bold: "",
          item: "Multiple centres across Mumbai for better accessibility",
        },
        {
          bold: "",
          item: "Complete cycle care: ovum pickup, embryo transfer, and post-transfer monitoring",
        },
        {
          bold: "",
          item: "Strict hygiene, safety, and emotional support systems",
        },
        {
          bold: "",
          item: "Dedicated fertility support team for end-to-end guidance",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "What infertility treatments are available at Acme Fertility in Mumbai ?",
          item: (
            <>
              <br />
              We offer IVF, ICSI, IUI, donor programs, fertility preservation,
              and advanced reproductive treatments.
            </>
          ),
        },
        {
          bold: "What is the cost of IVF treatment in Mumbai ?",
          item: (
            <>
              <br />
              Costs typically range from ₹1,00,000 to ₹2,00,000 depending on the
              case.
            </>
          ),
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: (
            <>
              <br />
              Take a warm bath, listen to soft music, or try gentle breathing
              exercises.
            </>
          ),
        },
        {
          bold: "How many Acme Fertility centres are there in Mumbai and where are they located ? ",
          item: (
            <>
              <br />
              We have centres in Borivali, Thane, and Dombivli.
            </>
          ),
        },
        {
          bold: (
            <>
              {" "}
              {" Why choose Acme Fertility as the "}
              <strong>
                <a
                  href="https://www.acmefertility.com/Programme/IVF"
                  title="best IVF centre in Mumbai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  best IVF centre in Mumbai ? <br />
                </a>
              </strong>
            </>
          ),
          item: "Because of advanced technology, experienced specialists, personalized care, and strong success-focused treatment protocols.",
        },
        {
          bold: " What is the appropriate time to visit an IVF Specialist in Mumbai ? ",
          item: (
            <>
              <br />
              If you have been unsuccessful at conceiving for a year or longer,
              it is best to seek the guidance of a fertility specialist.
            </>
          ),
        },
        {
          bold: "What are the available infertility treatments ? ",
          item: (
            <>
              <br />
              Most commonly, infertility treatments include medications, IUI,
              IVF, and other advanced methods of infertility treatment{" "}
              <b>Mumbai</b>.
            </>
          ),
        },
        {
          bold: "What criteria should I use to select the best fertility clinic in Mumbai ? ",
          item: (
            <>
              <br />
              Select the clinic with the best experienced, most skilled, and
              highest qualified staff, most advanced technology, the most
              transparent processes, and best patient support.
            </>
          ),
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_20: {
    L1: {
      liss1: [
        {
          bold: "",
          item: " ",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Male Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Male Infertility
                </a>
              </strong>
              {" Solutions:"}
            </>
          ),
          item: "Treatment for low sperm count or motility using ICSI, sperm retrieval techniques, and hormonal therapy.",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Female Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Female Infertility
                </a>
              </strong>
              {" Care:"}
            </>
          ),
          item: " Treatment for ovarian issues, uterine abnormalities, endometriosis, fibroids, tubal blockages, menopause-related infertility, and more.",
        },
        {
          bold: "Ovarian Rejuvenation:",
          item: "Support for low AMH and advanced maternal age cases.",
        },
        {
          bold: "IVF Failure Management:",
          item: "Detailed evaluation of previous IVF cycles with genetic analysis, surgical corrections, and immunological therapies where required.",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "",
          item: "State-of-the-art IVF laboratories and advanced embryology systems",
        },
        {
          bold: "",
          item: "Cost-effective IVF packages tailored to individual needs",
        },
        {
          bold: "",
          item: "Zero-interest EMI options for easy payment planning",
        },
        {
          bold: "",
          item: "Multiple centres across Mumbai for better accessibility",
        },
        {
          bold: "",
          item: "Multiple centres across Mumbai for better accessibility",
        },
        {
          bold: "",
          item: "Complete cycle care: ovum pickup, embryo transfer, and post-transfer monitoring",
        },
        {
          bold: "",
          item: "Strict hygiene, safety, and emotional support systems",
        },
        {
          bold: "",
          item: "Dedicated fertility support team for end-to-end guidance",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "What infertility treatments are available at Acme Fertility in Mumbai ?",
          item: (
            <>
              <br />
              We offer IVF, ICSI, IUI, donor programs, fertility preservation,
              and advanced reproductive treatments.
            </>
          ),
        },
        {
          bold: "What is the cost of IVF treatment in Mumbai ?",
          item: (
            <>
              <br />
              Costs typically range from ₹1,00,000 to ₹2,00,000 depending on the
              case.
            </>
          ),
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: (
            <>
              <br />
              Take a warm bath, listen to soft music, or try gentle breathing
              exercises.
            </>
          ),
        },
        {
          bold: "How many Acme Fertility centres are there in Mumbai and where are they located ? ",
          item: (
            <>
              <br />
              We have centres in Borivali, Thane, and Dombivli.
            </>
          ),
        },
        {
          bold: (
            <>
              {" "}
              {" Why choose Acme Fertility as the "}
              <strong>
                <a
                  href="https://www.acmefertility.com/Programme/IVF"
                  title="best IVF centre in Mumbai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  best IVF centre in Mumbai ? <br />
                </a>
              </strong>
            </>
          ),
          item: "Because of advanced technology, experienced specialists, personalized care, and strong success-focused treatment protocols.",
        },
        {
          bold: " What is the appropriate time to visit an IVF Specialist in Mumbai ? ",
          item: (
            <>
              <br />
              If you have been unsuccessful at conceiving for a year or longer,
              it is best to seek the guidance of a fertility specialist.
            </>
          ),
        },
        {
          bold: "What are the available infertility treatments ? ",
          item: (
            <>
              <br />
              Most commonly, infertility treatments include medications, IUI,
              IVF, and other advanced methods of infertility treatment{" "}
              <b>Mumbai</b>.
            </>
          ),
        },
        {
          bold: "What criteria should I use to select the best fertility clinic in Mumbai ? ",
          item: (
            <>
              <br />
              Select the clinic with the best experienced, most skilled, and
              highest qualified staff, most advanced technology, the most
              transparent processes, and best patient support.
            </>
          ),
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_21: {
    L1: {
      liss1: [
        {
          bold: "",
          item: " ",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Male Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                ></a>
              </strong>
              {" :"}
            </>
          ),
          item: "",
        },
        {
          bold: (
            <>
              <strong>
                <a
                  href="https://www.acmefertility.com/MaleInfertility"
                  title="Female Infertility"
                  target="_blank"
                  rel="noopener noreferrer"
                ></a>
              </strong>
              {" Care:"}
            </>
          ),
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "",
          item: (
            <>
              <br />
            </>
          ),
        },
        {
          bold: "",
          item: (
            <>
              <br />
            </>
          ),
        },
        {
          bold: "",
          item: (
            <>
              <br />
            </>
          ),
        },
        {
          bold: "",
          item: (
            <>
              <br />
            </>
          ),
        },
        {
          bold: (
            <>
              {" "}
              {""}
              <strong>
                <a
                  href="https://www.acmefertility.com/Programme/IVF"
                  title="best IVF centre in Mumbai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <br />
                </a>
              </strong>
            </>
          ),
          item: "",
        },
        {
          bold: " ",
          item: <></>,
        },
        {
          bold: "",
          item: <></>,
        },
        {
          bold: "",
          item: <></>,
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
  },
  Blog_22: {
    L1: {
      liss1: [
        {
          bold: "Hormone evaluation",
          // item: " "
        },
        {
          bold: "Ovarian reserve testing",
          // item: ""
        },
        {
          bold: "Ultrasound scans",
          // item: ""
        },
        {
          bold: "Fallopian tube assessment",
          // item: ""
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Semen analysis",
          item: "",
        },
        {
          bold: "Hormonal testing",
          item: "",
        },
        {
          bold: "Genetic screening when necessary",
          item: "",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Medical history review",
          item: "",
        },
        {
          bold: "Lifestyle assessment",
          item: "",
        },
        {
          bold: "Previous pregnancy outcomes",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
  },
  Blog_23: {
    L1: {
      liss1: [
        {
          bold: "Fellowship in Reproductive Medicine (FNB/DNB)",
          // item: " "
        },
        {
          bold: "Membership in ISAR or ESHRE",
          // item: ""
        },
        {
          bold: "Minimum 8–10 years of dedicated fertility practice",
          // item: ""
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "No transparency on success rates",
          item: "",
        },
        {
          bold: "Pushing IVF before exploring lower-cost options like IUI",
          item: "",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Medical history review",
          item: "",
        },
        {
          bold: "Lifestyle assessment",
          item: "",
        },
        {
          bold: "Previous pregnancy outcomes",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
        {
          bold: "",
          item: "",
        },
      ],
    },
  },
  Blog_24: {
    L1: {
      liss1: [
        {
          bold: "Female and male infertility",
          // item: " "
        },
        {
          bold: "Fertility issues with no identifiable cause",
          // item: ""
        },
        {
          bold: "PCOS and endometriosis",
          // item: ""
        },
        {
          bold: "Low ovarian reserve",
        },
        {
          bold: "Recurrent pregnancy loss",
        },
        {
          bold: "Women of advanced maternal age",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "An advanced Laboratory for IVF",
          item: "",
        },
        {
          bold: "Blastocyst Culture",
          item: "",
        },
        {
          bold: "Embryo, Egg and Sperm Banking",
        },
        {
          bold: "Time lapse monitoring of embryos",
        },
        {
          bold: "Controlled Quality of Embryos",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Personal medical history",
          item: "",
        },
        {
          bold: "Endocrinology testing",
          item: "",
        },
        {
          bold: "Age",
          item: "",
        },
        {
          bold: "Previous treatments for Fertility",
          item: "",
        },
        {
          bold: "Imaging studies and ultrasound",
          item: "",
        },
        {
          bold: "Semen Studies",
          item: "",
        },
        {
          bold: "Personal lifestyle",
          item: "",
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Blocked fallopian tubes",
          item: "",
        },
        {
          bold: "Extreme male infertility",
          item: "",
        },
        {
          bold: "Endometriosis",
          item: "",
        },
        {
          bold: "Low ovarian reserve",
          item: "",
        },
        {
          bold: "Multiple failed IUI cycles",
          item: "",
        },
        {
          bold: "Idiopathic infertility",
          item: "",
        },
      ],
    },
    L5: {
      liss5: [
        {
          bold: "Cancer Therapy",
          item: "",
        },
        {
          bold: "Planned Deferred Parenthood",
          item: "",
        },
        {
          bold: "Certain Medical Conditions",
          item: "",
        },
      ],
    },
    L6: {
      liss6: [
        {
          bold: "Semen Analysis",
          item: "",
        },
        {
          bold: "Hormonal Evaluation",
          item: "",
        },
        {
          bold: "Lifestyle Evaluation",
          item: "",
        },
        {
          bold: "Advanced Sperm Selection Methods",
        },
      ],
    },
    L7: {
      liss7: [
        {
          bold: "State-of-the-art IVF labs",
          item: "",
        },
        {
          bold: "Highly skilled fertility specialists",
          item: "",
        },
        {
          bold: "International standards for treatment",
          item: "",
        },
        {
          bold: "Advanced reproductive techniques",
        },
        {
          bold: "Comprehensive fertility care",
        },
        {
          bold: "Good accessibility",
        },
      ],
    },
    L8: {
      liss8: [
        {
          bold: "Makes follow-up visits easier",
          item: "",
        },
        {
          bold: "Improves continuity of care",
          item: "",
        },
        {
          bold: "Reduces the stress of travel",
          item: "",
        },
        {
          bold: "Provides faster access during treatment cycles",
        },
      ],
    },
    L9: {
      liss9: [
        {
          bold: "You have been attempting to conceive for more than one year.",
        },
        {
          bold: "You are trying to conceive after 35 and have been trying for six months.",
        },
        {
          bold: "You have irregular monthly cycles.",
        },
        {
          bold: "You have experienced several miscarriages.",
        },
        {
          bold: "You suffer from PCOS or endometriosis.",
        },
        {
          bold: "Your partner has an abnormal semen analysis.",
        },
        {
          bold: "You have blocked fallopian tubes.",
        },
        {
          bold: "You have infertility which is unexplained.",
        },
        {
          bold: "You have been trying to conceive for more than six months if you are at least 40 years old.",
        },
      ],
    },
    L10: {
      liss10: [
        {
          bold: "What procedures or diagnostic tests will be performed and when?",
          item: "",
        },
        {
          bold: "What are the treatment options for me?",
          item: "",
        },
        {
          bold: "Does IVF have to be done at this time?",
          item: "",
        },
        {
          bold: "What type of technology is in the laboratory?",
        },
        {
          bold: "How is this treatment custom to me?",
        },
        {
          bold: "Are there resources for emotional support during this process?",
        },
        {
          bold: "What is the standard aftercare for this process?",
        },
      ],
    },
    L11: {
      liss11: [
        {
          bold: "Personalized fertility evaluations",
        },
        {
          bold: "Personalized fertility evaluations",
        },
        {
          bold: "Advanced IVF laboratory",
        },
        {
          bold: "Modern reproductive technology",
        },
        {
          bold: "Ethical and transparent treatment planning",
        },
        {
          bold: "Comprehensive IVF and IUI services",
        },
        {
          bold: "Fertility preservation options",
        },
        {
          bold: "Compassionate patient support throughout the journey",
        },
      ],
    },
    L12: {
      liss12: [
        {
          bold: "The doctors' expertise",
        },
        {
          bold: "The experience of the staff",
        },
        {
          bold: "The quality of the labs",
        },
        {
          bold: "The level of individualized care",
        },
        {
          bold: "Patient testimonials",
        },
        {
          bold: "How upfront they are about the process",
        },
        {
          bold: "Other fertility services they provide",
        },
      ],
    },
    L13: {
      liss13: [
        {
          bold: "Improved ease of planning and going to appointments",
        },
        {
          bold: "Way less travel time for those important appointments",
        },
        {
          bold: "Easy working relationships with the doctors",
        },
        {
          bold: "Shorter wait times if a doctor needs to be brought in",
        },
        {
          bold: "The overall process is less stressful",
        },
      ],
    },
    L14: {
      liss14: [
        {
          bold: "Scheduling the complete fertility workup",
        },
        {
          bold: "Offering tailored IVF treatment options",
        },
        {
          bold: "Outlining the best fertility options for you",
        },
        {
          bold: "Guiding you on the best start for your journey to parenthood.",
        },
      ],
    },
  },
  Blog_25: {
    L1: {
      liss1: [
        {
          bold: "Tubal blockages or damage",
          item: " ",
        },
        {
          bold: "Ovulation disorders like PCOS",
          item: "",
        },
        {
          bold: "Severe male infertility",
          item: "",
        },
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Identifies chromosomal issues",
        },
        {
          bold: "Lowers miscarriage chances",
        },
        {
          bold: "Supports family balancing (where legally applicable)",
        },
      ],
    },
    L3: {
      liss3: [
        {
          bold: "What infertility treatments are available at Acme Fertility in Mumbai ?",
          item: (
            <>
              <br />
              We offer IVF, ICSI, IUI, donor programs, fertility preservation,
              and advanced reproductive treatments.
            </>
          ),
        },
        {
          bold: "What is the cost of IVF treatment in Mumbai ?",
          item: (
            <>
              <br />
              Costs typically range from ₹1,00,000 to ₹2,00,000 depending on the
              case.
            </>
          ),
        },
        {
          bold: "Create a calming bedtime ritual: ",
          item: (
            <>
              <br />
              Take a warm bath, listen to soft music, or try gentle breathing
              exercises.
            </>
          ),
        },
        {
          bold: "How many Acme Fertility centres are there in Mumbai and where are they located ? ",
          item: (
            <>
              <br />
              We have centres in Borivali, Thane, and Dombivli.
            </>
          ),
        },
        {
          bold: (
            <>
              {" "}
              {" Why choose Acme Fertility as the "}
              <strong>
                <a
                  href="https://www.acmefertility.com/Programme/IVF"
                  title="best IVF centre in Mumbai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  best IVF centre in Mumbai ? <br />
                </a>
              </strong>
            </>
          ),
          item: "Because of advanced technology, experienced specialists, personalized care, and strong success-focused treatment protocols.",
        },
        {
          bold: " What is the appropriate time to visit an IVF Specialist in Mumbai ? ",
          item: (
            <>
              <br />
              If you have been unsuccessful at conceiving for a year or longer,
              it is best to seek the guidance of a fertility specialist.
            </>
          ),
        },
        {
          bold: "What are the available infertility treatments ? ",
          item: (
            <>
              <br />
              Most commonly, infertility treatments include medications, IUI,
              IVF, and other advanced methods of infertility treatment{" "}
              <b>Mumbai</b>.
            </>
          ),
        },
        {
          bold: "What criteria should I use to select the best fertility clinic in Mumbai ? ",
          item: (
            <>
              <br />
              Select the clinic with the best experienced, most skilled, and
              highest qualified staff, most advanced technology, the most
              transparent processes, and best patient support.
            </>
          ),
        },
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Practice mindfulness or meditation: ",
          item: "Even 10 minutes a day can lower stress hormones.",
        },
        {
          bold: "Exercise moderately: ",
          item: "Activities like walking, yoga, or stretching can help release “feel-good” hormones.",
        },
        {
          bold: "Talk it out: ",
          item: "Share your feelings with your partner or a counselor. Joining a support group can also help you feel less alone.",
        },
        {
          bold: "Set realistic expectations: ",
          item: "IVF success takes time. Allow yourself to feel every emotion, and be kind to yourself.",
        },
      ],
    },
  },
  Blog_28: {
    L1: {
      liss1: [
        {
          bold: "Higher embryo quality",
          item: " ",
        },
        {
          bold: "Lower chromosomal abnormality rates",
          item: "",
        },
        {
          bold: "Better implantation potential",
          item: "",
        },
        {
          bold: "Reduced miscarriage risk",
        },
      ],
    },
    L5a: {
      liss5a: [
        {
          bold: "Maintain a BMI between 19 and 25.",
        },
        {
          bold: "Take folic acid (400–800 mcg daily).",
        },
        {
          bold: "Sleep 7–8 hours each night.",
        },
        {
          bold: "Avoid tobacco and recreational drugs.",
        },
        {
          bold: "Limit caffeine to under 200 mg per day.",
        },
        {
          bold: "Manage stress through yoga, meditation, or counseling.",
        },
      ],
    },
    L5b: {
      liss5b: [
        {
          bold: "Preimplantation Genetic Testing (PGT)",
        },
        {
          bold: "Time-lapse embryo monitoring",
        },
        {
          bold: "Endometrial receptivity assessment",
        },
        {
          bold: "Sperm DNA fragmentation treatment",
        }
      ],
    },
    L6: {
      liss6: [
        {
          bold: "Advanced embryology laboratory",
          
        },
        {
          bold: "Experienced IVF specialists",
          
        },
        {
          bold: "International-standard IVF protocols",
          
        },
        {
          bold: "Personalized fertility treatment plans",
         
        },
        {
          bold: "Ethical and transparent care"
        },
        {
          bold: "Comprehensive male and female fertility evaluation"
        },
        {
          bold: "Advanced genetic testing and embryo selection"
        }
      ],
    },
    L8: {
      liss8: [
        {
          bold: "Indian Council of Medical Research (ICMR) – National ART Registry, 2024",
          item: " ",
        },
        {
          bold: "European Society of Human Reproduction and Embryology (ESHRE), 2024",
          item: "",
        },
        {
          bold: "American Society for Reproductive Medicine (ASRM), 2023",
          item: "",
        },
        {
          bold: "Indian Society for Assisted Reproduction (ISAR), 2025",
        },
      ],
    }
  },
  Blog_29: {
    L1: {
      liss1: [
        {
          bold: "Myth : ",
          item: "Infertility testing is a woman's appointment.",
        },
        {
          bold: "Fact : ",
          item: "A semen analysis is simple, quick, and should happen alongside female evaluation",
        },
        {
          bold: "Why it matters : ",
          item: "Skipping male evaluation can mean missing the real cause entirely.",
        }
        
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Age of the eggs  — ",
          item: "the single biggest factor in outcome."
        },
        {
          bold: "Underlying diagnosis —",
          item: "blocked tubes, PCOS, or unexplained infertility respond differently."
        },
        {
          bold: "Embryo quality —",
          item: "determined in the lab after fertilization."
        }
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Full medical and family history",
          
        },
        {
          bold: "Age-appropriate cancer screenings (Pap smears, mammograms)",
          
        },
        {
          bold: "Baseline hormonal and reproductive health panel",
          
        }
      ],
    },
    L8: {
      liss8: [
        {
          bold: "Indian Council of Medical Research (ICMR) – National ART Registry, 2024",
          item: " ",
        },
        {
          bold: "European Society of Human Reproduction and Embryology (ESHRE), 2024",
          item: "",
        },
        {
          bold: "American Society for Reproductive Medicine (ASRM), 2023",
          item: "",
        },
        {
          bold: "Indian Society for Assisted Reproduction (ISAR), 2025",
        },
      ],
    }
  },
  Blog_30: {
    L1: {
      liss1: [
        {
          bold: "Lab accreditation and embryologist credentials",
          item: "",
        },
        {
          bold: "Transparent published success rates by age group",
          item: "",
        },
        {
          bold: "Whether the same doctor manages your case start to finish",
          item: "",
        }
        
      ],
    },
    L2: {
      liss2: [
        {
          bold: "How many years have you personally practiced reproductive medicine?",
          item: ""
        },
        {
          bold: "What is your clinic's live birth rate for my age group?",
          item: ""
        },
        {
          bold: "Will you personally oversee my cycle, or will it be handed off?",
          item: ""
        }
      ],
    },
    L3: {
      liss3: [
        {
          bold: "IVF & ICSI —",
          item: "for tubal, male-factor, or unexplained infertility"
        },
        {
          bold: "Fertility preservation —",
          item: "egg and sperm freezing"
        },
        {
          bold: "Donor & surrogacy programs —",
          item: "for specific medical circumstances"
        }
      ],
    },
    L5: {
      liss5: [
        {
          bold: "Age and ovarian reserve",
          item: " ",
        },
        {
          bold: "Underlying diagnosis (male-factor, tubal, unexplained)",
          item: "",
        },
        {
          bold: "Lab quality and embryo grading standards",
          item: "",
        }
      ],
    }
  },
  Blog_31: {
    L1: {
      liss1: [
        {
          bold: "Fertility evaluation",
          item: "",
        },
        {
          bold: "Hormone testing",
          item: "",
        },
        {
          bold: "Ultrasound monitoring",
          item: "",
        },
        {
          bold: "Male fertility testing"
        },
        {
          bold: "IVF & ICSI"
        },
        {
          bold: "IUI"
        },
        {
          bold: "Egg & embryo freezing"
        },
        {
          bold: "Pregnancy care"
        }     
      ],
    },
    L2: {
      liss2: [
        {
          bold: "Eggs are fertilized outside the body.",
          item: ""
        },
        {
          bold: "Embryos are transferred into the uterus.",
          item: ""
        },
        {
          bold: "Ideal for blocked tubes, endometriosis, or unexplained infertility.",
          item: ""
        }
      ],
         liss2a: [
        {
          bold: "Prepared sperm is placed directly into the uterus.",
          item: ""
        },
        {
          bold: "Suitable for mild male infertility or ovulation disorders.",
          item: ""
        },
        {
          bold: "Less invasive and more affordable than IVF.",
          item: ""
        }
      ],
         liss2b: [
        {
          bold: "A single healthy sperm is injected into an egg.",
          item: ""
        },
        {
          bold: "Recommended for severe male infertility.",
          item: ""
        },
        {
          bold: "Often combined with IVF.",
          item: ""
        }
      ],
    },
    L3: {
      liss3: [
        {
          bold: "Experienced fertility specialists",
          
        },
        {
          bold: "Modern IVF laboratory",
          
        },
        {
          bold: "High-quality embryology team",
          
        },
        {
          bold: "Transparent pricing"
        },
        {
          bold: "Personalized treatment plans"
        },
        {
          bold: "Positive patient reviews"
        },
        {
          bold: "Comprehensive fertility services"
        }
      ],
    },
    L4: {
      liss4: [
        {
          bold: "Blood hormone tests",
          item: " ",
        },
        {
          bold: "Pelvic ultrasound",
          item: "",
        },
        {
          bold: "Semen analysis",
          item: "",
        },
        {
          bold: "AMH testing"
        },
        {
          bold: "HSG for fallopian tubes"
        }
      ],
    },
    L5: {
      liss5: [
        {
          bold: "Experienced fertility specialists",
          item: " ",
        },
        {
          bold: "Modern IVF laboratory",
          item: "",
        },
        {
          bold: "Personalized care",
          item: "",
        },
        {
          bold: "Advanced fertility treatments"
        },
        {
          bold: "Patient-focused counseling"
        },
        {
          bold: "Comprehensive women's healthcare"
        }
      ],
    }
  },
};

export default ListContent;
